import type {components} from '../../openapi';
import {axiosInstance} from '../axiosInstance';

export type ApplyVacancyRequest = components['schemas']['Id'];
export type ApplyVacancyResponse = components['schemas']['ExtendedVacancy'];

/** POST `/api/executor_web/v1/executor_web/vacancies/apply` — см. `paths['/executor_web/vacancies/apply']` в openapi */
export function applyVacancy(body: ApplyVacancyRequest, signal?: AbortSignal) {
	return axiosInstance.post<ApplyVacancyResponse>('vacancies/apply', body, {signal});
}
